/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsModeratorControllerGetProductFeaturesQueryResponse,
  TelegramProductsModeratorControllerGetProductFeaturesPathParams,
  TelegramProductsModeratorControllerGetProductFeatures401,
  TelegramProductsModeratorControllerGetProductFeatures404,
} from '../types/TelegramProductsModeratorControllerGetProductFeatures.ts';

function getTelegramProductsModeratorGetProductFeaturesUrl(
  id: TelegramProductsModeratorControllerGetProductFeaturesPathParams['id'],
) {
  const res = { method: 'GET', url: `/api/moderator/telegram/products/features/${id}` as const };
  return res;
}

/**
 * {@link /api/moderator/telegram/products/features/:id}
 */
export async function telegramProductsModeratorGetProductFeatures(
  id: TelegramProductsModeratorControllerGetProductFeaturesPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsModeratorControllerGetProductFeaturesQueryResponse,
    ResponseErrorConfig<
      | TelegramProductsModeratorControllerGetProductFeatures401
      | TelegramProductsModeratorControllerGetProductFeatures404
    >,
    unknown
  >({ method: 'GET', url: getTelegramProductsModeratorGetProductFeaturesUrl(id).url.toString(), ...requestConfig });
  return res.data;
}
